/** `frontDoor.scorecards.enabled`: on unless set to false. @public */
export function scorecardsEnabled(config: {
  getOptionalBoolean(key: string): boolean | undefined;
}): boolean {
  return config.getOptionalBoolean("frontDoor.scorecards.enabled") ?? true;
}
